export default {

    // Updates user info in state and localstorage
    UPDATE_USER_INFO(state, payload) {
        for (const property of Object.keys(payload)) {
            if (payload[property] != null) {
                state.AppActiveUser[property] = payload[property];
            }
        }
    },

    // Updates users positions
    SET_USERS_POSITIONS(state, list) {
        state.AppActiveUser.positions = [];
        for (const pos of Object.values(list)) {
            state.AppActiveUser.positions.push(pos.position_id);
        }
    },

    UPDATE_USER_AVATAR(state, avatar) {
        state.AppActiveUser = Object.assign({}, state.AppActiveUser, {avatar: avatar})
    },

    UPDATE_USER_FIELDS(state, user) {
        for (const fld of Object.keys(user)) {
            if (user[fld] != null && state.AppActiveUser[fld] !== user[fld]) {
                let tmp = {}
                tmp[fld] = user[fld]
                state.AppActiveUser = Object.assign({}, state.AppActiveUser, tmp)
            }
        }
    }
}
